import React from "react";
import {
  RiCheckboxBlankCircleFill,
  RiCheckboxBlankCircleLine,
} from "react-icons/ri";
import "./PromoCode.css";

const ViewMorePormo = ({
  handleSelectCoupon,
  availableCoupons,
  setShowAllCouponsModal,
  appliedCode,
}) => {
  return (
    <div className="mobile modalOverlay">
      <div className="modalBox">
        <div
          className="close-btn"
          onClick={() => setShowAllCouponsModal(false)}
        >
          ✕
        </div>
        <h3>Apply Promo Code</h3>

        {availableCoupons.map((coupon) => (
          <div
            key={coupon.id}
            className="pointer promoContent"
            style={{
              backgroundColor: "rgb(242, 242, 242)",
              marginBottom: "10px",
              borderRadius: "8px",
              padding: "8px",
            }}
            onClick={() => {
              handleSelectCoupon(coupon.coupon_code);
              setShowAllCouponsModal(false);
            }}
          >
            <div className="makeFlex pointer gap-x-5 align-items-center">
              <span className="radioWrap">
                {appliedCode === coupon.coupon_code ? (
                  <RiCheckboxBlankCircleFill color="#2196f3" />
                ) : (
                  <RiCheckboxBlankCircleLine color="#2196f3" />
                )}
              </span>
              <div className="promoContentWrap flexOne">
                <span className="couponCode">
                  {coupon.coupon_code}
                </span>
                <span
                  className="promoCheckContent"
                  dangerouslySetInnerHTML={{
                    __html: coupon.shortdescription,
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ViewMorePormo;
